module.exports = __webpack_public_path__ + "static/media/laban.ec4a27d0.png";